var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEinzelnNoCompanyCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 780 780",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-219.538,0.152726)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.26031,0,0,1.26031,-618.165,-974.201)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 974.814,
    cy: 1083.26,
    r: 285.066,
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "3.31px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00825,0,0,1.00825,-372.451,-701.15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 974.814,
    cy: 1083.26,
    r: 285.066,
    style: {
      fill: "rgb(255,235,0)",
      stroke: "black",
      strokeWidth: "4.13px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.756188,0,0,0.756188,-126.737,-428.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 974.814,
    cy: 1083.26,
    r: 285.066,
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "5.51px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.504125,0,0,0.504125,118.978,-155.049)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 974.814,
    cy: 1083.26,
    r: 285.066,
    style: {
      fill: "rgb(255,235,0)",
      stroke: "black",
      strokeWidth: "8.27px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.252063,0,0,0.252063,364.692,118.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 974.814,
    cy: 1083.26,
    r: 285.066,
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "16.53px",
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30482,0,0,1.37956,-220.613,-581.23)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(125,0,0,125,900.489,664.065)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "390.114px",
    y: "664.065px",
    style: {
      fontFamily: "'Silom'",
      fontSize: 125,
      fillOpacity: 0.12
    }
  }, "WinFire")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.30482,0,0,1.37956,-238.841,-598.497)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(125,0,0,125,900.489,664.065)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "390.114px",
    y: "664.065px",
    style: {
      fontFamily: "'Silom'",
      fontSize: 125
    }
  }, "WinFire")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.21674,0,0,1.21674,-327.922,-1055.2)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.3333,0,0,83.3333,799.018,1218.88)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "743.435px",
    y: "1218.88px",
    style: {
      fontFamily: "'Silom'",
      fontSize: "83.333px"
    }
  }, "5"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEinzelnNoCompanyCenter);
export default __webpack_public_path__ + "static/media/LogoEinzelnNoCompanyCenter.4847506f3f047d7fd4385a0a3bacc9f5.svg";
export { ForwardRef as ReactComponent };